export const routePage = (history, ad, type) => {
  const params = new URLSearchParams(window.location.search);

  // 只在有 ad 的情况下才拼
  if (ad !== undefined && ad !== null && ad !== "") {
    params.set("ad", ad);
  }
  console.log(params);
  

  history.push({
    pathname: type,
    search: params.toString() ? `?${params.toString()}` : "",
  });
};
